import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import AppSettings from "../../configs/appSettings";
import "./style.css";
import {Image, ImageType} from "../../models/image";

const ImageCard = ({ image, sku, waterMark, handleSelectImage }: { image: Image, sku: string, waterMark: number, handleSelectImage: any }) => {
  let link =`${AppSettings.ApiBaseUrl}/${'api/images/full-size-image?type=product&filetype=main&filename=' + image.ImageId + '&watermark=' + waterMark}`;

  return (
    <div className="image-page-cards">
      <div style={{marginBottom:'10px'}}>
        <input id="chkSelect" name="chkSelect" type="checkbox" className="chkSelect" value={image.ImageId ?? ""} checked={image.IsChecked} onChange={(e) => { handleSelectImage(e, image.ImageId, image.FileName);}} /> Select
      </div>
      <Card className="image-cards">
        <a href={link} target="_blank" className="watermark">
          <img className="card-img prd-card-img" title={image.FileName} src={image.Thumbnail}></img>
        </a>
      </Card>
    </div>
  );
};

export default ImageCard;
